import script from "./TopIdlePowers.vue?vue&type=script&setup=true&lang=js"
export * from "./TopIdlePowers.vue?vue&type=script&setup=true&lang=js"

import "./TopIdlePowers.vue?vue&type=style&index=0&id=cab18756&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cab18756"]])

export default __exports__